import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Container, Eyebrow, Heading } from '../ui/Section';
import { VERBS } from '../../data/site';
const FRAGMENTED = ['Transporte', 'Mantenimiento', 'Limpieza', 'Seguridad', 'Control documental', 'Consultoría', 'Tecnología', 'Proveedores', 'Reportes', 'HSE'];
export function IntegrationModel() {
  return <section className="bg-white py-20 md:py-28" data-id="element-327" data-mp="2uz6u2de4hird">
      <Container data-id="element-328" data-mp="2yzqsrlecgufm">
        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-329" data-mp="2z08xz7iziizo">
          <div data-id="element-330" data-mp="2yxeat88l6k2k">
            <Eyebrow data-id="element-331" data-mp="2l07vjnn2n3i3">Una empresa. Toda la operación.</Eyebrow>
            <Heading as="h2" size="lg" className="mt-5" data-id="element-332" data-mp="2kzpp5y6p38wg">
              Menos proveedores.
              <br data-id="element-333" data-mp="2px7s97y16twj" />
              Más control.
            </Heading>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-graphite-500" data-id="element-334" data-mp="19jrdrno1oas2">
              Centralizamos servicios, información y gestión para reducir fricción, duplicidades, costos innecesarios y
              pérdida de visibilidad operacional.
            </p>
            <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-3" data-id="element-335" data-mp="37x416kmhzeuu">
              {VERBS.map(verb => <li key={verb} className="font-display text-xl font-bold tracking-tight text-graphite-900" data-id="element-336" data-mp="3lwc0remkoozk">
                  {verb}.
                </li>)}
            </ul>
          </div>

          <div className="grid items-center gap-6 sm:grid-cols-[1fr_auto_1fr]" data-id="element-337" data-mp="3uws48o3bfw4f">
            <div data-id="element-338" data-mp="3qvoo00hcvy2o">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-graphite-500" data-id="element-339" data-mp="3qw8a7te1h8mi">Modelo habitual</p>
              <ul className="mt-4 space-y-1.5" data-id="element-340" data-mp="8gnvp2vxv00m">
                {FRAGMENTED.map((item, i) => <motion.li key={item} initial={{
                opacity: 0,
                x: -6
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.2,
                delay: i * 0.03,
                ease: [0.23, 1, 0.32, 1]
              }} className="border border-mist-200 bg-mist-50 px-3 py-2 text-xs text-graphite-500" data-id="element-341" data-mp="3jnpmrz39x9i" data-mpi={i}>
                    {item}
                  </motion.li>)}
              </ul>
              <p className="mt-3 text-xs text-graphite-500" data-id="element-342" data-mp="ugli6e7pvg4x">10 contratos. 10 interlocutores.</p>
            </div>

            <div className="flex justify-center sm:px-2" data-id="element-343" data-mp="za7n1k7n2fq6">
              <ArrowRightIcon className="h-6 w-6 rotate-90 text-accent-500 sm:rotate-0" aria-hidden="true" data-id="element-344" data-mp="148rajp1vrzkn" />
            </div>

            <div className="bg-brand-800 p-7 text-white" data-id="element-345" data-mp="188016l1mjhbz">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-accent-400" data-id="element-346" data-mp="1d85z2iyhm02i">Modelo Rabemar</p>
              <p className="mt-4 font-display text-2xl font-bold leading-tight tracking-tight" data-id="element-347" data-mp="1i6pk8h59b7tt">
                Un ecosistema operativo coordinado
              </p>
              <p className="mt-4 text-sm leading-relaxed text-mist-200" data-id="element-348" data-mp="3jz41rf3w2a9p">
                Rabemar integra recursos humanos, proveedores, tecnología, procesos, control y ejecución dentro de una
                única gestión, con un punto de contacto responsable de toda la operación.
              </p>
              <ul className="mt-7 space-y-2 border-t border-white/15 pt-5 text-sm text-mist-200" data-id="element-349" data-mp="32pt2qpndsl3m">
                <li data-id="element-350" data-mp="2xqq9e2grk3bh">1 contrato integral</li>
                <li data-id="element-351" data-mp="2xs199r738qxb">1 Account Manager</li>
                <li data-id="element-352" data-mp="2xovlcfa73v36">1 vista de indicadores y cumplimiento</li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}